const breakpoints = {
    extraLarge: 1500,
    large: 1199,
    medium: 992,
    minuscule: 360,
    small: 767,
    smaller: 650,
    tiny: 575,
    tinyier: 490,
};

const theme = {
    breakpoints,
    embedTitle: "#404646",
    iconColor: "#878787",
    tertiaryColor: "#039BE5",
    textColor: "#878787",
    title: "#000000",
};

export default theme;
